import React, { useEffect, useState } from "react";

const ScrolToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsVisible((window.scrollY || window.pageYOffset || 0) > 900);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleClick = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <button
            type="button"
            className="scroltop"
            onClick={handleClick}
            style={{ display: isVisible ? 'block' : 'none' }}
        >
            <span className="fa fa-angle-up relative" id="btn-vibrate" />
        </button>
    );
};

export default ScrolToTop;
